import React from 'react';
import Footer from '../../../layout/Footer/Footer';
import Popovers from '../../../components/bootstrap/Popovers';

import classNames from 'classnames';

const DefaultFooter = () => {
	return (
		<Footer>
			<div className='container-fluid'>
				<div className={classNames('text-center text-decoration-none me-3')}
						>
					Legal APPS Dompet Dhuafa Enterprise System
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
